import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BrowserRouter as Router, Link } from "react-router-dom";
import NavbarTop from "../NavbarTop";
import Footer from "../Footer";
import MenuCategories from "../MenuCategories";
import MenuInicioRapido from "../MenuInicioRapido";
import {
  CircleStackIcon,
  QuestionMarkCircleIcon,
} from "@heroicons/react/24/outline";

export default function DataIntelligence() {
  useEffect(() => {
    // Rola a página para o topo sempre que a página é carregada
    window.scrollTo(0, 0);
  }, []); // Executa o efeito apenas uma vez, quando o componente é montado

  return (
    <>
      <section>
        <div>
          <NavbarTop />
        </div>

        <div className="container col-md-11 minha-div">
          <div className="row content section paddingt-2 white-background">
            <div className="col-md-12">
              <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item active">Data Intelligence</li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuCategories />
            </div>

            <div className="col-md-6">
              <h1>
                <CircleStackIcon className="icon-title-size" /> Data
                Intelligence
                <h5 style={{ paddingLeft: "50px" }}>Enriquecimento de dados</h5>
              </h1>

              <hr />

              <br></br>

              <ul className="nav flex-column articles-listing">
                <NavItem to="/o-que-e-enriquecimento-de-dados">
                  O que é enriquecimento de dados?
                </NavItem>
                <NavItem to="/como-enriquecer-meus-dados">
                  Como enriquecer meus dados?
                </NavItem>
                <NavItem to="/solucao-de-problemas-enriquecimento-com-erro-ou-pendencias">
                Solução de problemas - Enriquecimento com erro ou pendências
                </NavItem>
              </ul>
            </div>

            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuInicioRapido />
            </div>
          </div>
        </div>
      </section>

      <br></br>
      <br></br>

      <Footer />
    </>
  );
}

function NavItem({ to, children }) {
  return (
    <li className="faq-item mb-5">
      <Link to={to}>
        <QuestionMarkCircleIcon className="icon-text-size" /> {children}
      </Link>
    </li>
  );
}
